// Constants
export const datos_razon = () => {
  return {
    datos_razon: {
      id: {
        namepath: ['admin_razones'],        
        type: "number",
        label: "id",
        placeholder: "",
        description: "",
        validate: "",
        datatype: {
          type: "input",
          disabled: true,
          predeterminate: "",
        }
      },
      id_list_estado: {
        type: "text",
        label: "Estado",
        placeholder: "",
        namepath: ['admin_razones'],
        description: "",
        validate: "",
        datatype: {
          type: "select",
          disabled: false,
          predeterminate: 1,
          list: "list_estado",
          label: 'name'
        }
      }, 
      id_list_documento: {
        type: "text",
        label: "Tipo",
        placeholder: "",
        namepath: ['admin_razones'],
        description: "",
        validate: "",
        datatype: {
          type: "select",
          disabled: false,
          predeterminate: "1",
          list: "list_documento",
          label: 'name'
        }
      },
      documento: {
        type: "number",
        label: "Documento",
        placeholder: "",
        namepath: ['admin_razones'],
        description: "",
        validate: "required",
        datatype: {
          type: "price",
          disabled: false,
          predeterminate: "",
          prepend: '',
          append: '',
        }
      },
      dv: {
        type: "number",
        label: "DV",
        placeholder: "",
        namepath: ['admin_razones'],
        description: "",
        validate: "required|maxLength:1",
        datatype: {
          type: "price",
          disabled: false,
          predeterminate: 0,
          prepend: '',
          append: '',
        }
      },
      name: {
        type: "text",
        label: "Nombre Comercial",
        placeholder: "",
        namepath: ['admin_razones','facturacion_descargas','facturacion_descargarafl','facturacion_afiliacion'],
        description: "",
        validate: "required",
        datatype: {
          type: "input",
          disabled: false,
          predeterminate: "",
        }
      },
      nombre: {
        type: "text",
        placeholder: "",
        label: "Razón Social",
        namepath: ['admin_razones','facturacion_descargas','facturacion_descargarafl','facturacion_afiliacion'],
        description: "",
        validate: "required",
        datatype: {
          type: "input",
          disabled: false,
          predeterminate: "",
        }
      },
      direccion: {
        type: "text",
        label: "Dirección",
        placeholder: "",
        namepath: ['admin_razones'],
        description: "",
        validate: "",
        datatype: {
          type: "input",
          disabled: false,
          predeterminate: null,
        }
      },
      telefonos: {
        type: "text",
        label: "Teléfonos",
        placeholder: "",
        namepath: ['admin_razones'],
        description: "",
        validate: "",
        datatype: {
          type: "input",
          disabled: false,
          predeterminate: null,
        }
      },
      email: {
        type: "text",
        label: "Email",
        placeholder: "",
        namepath: ['admin_razones'],
        description: "",
        validate: "",
        datatype: {
          type: "email",
          disabled: false,
          predeterminate: null,
        }
      },
      id_list_aportante: {
        type: "text",
        label: "Clase de aportante",
        placeholder: "",
        namepath: ['admin_razones'],
        description: "",
        validate: "",
        datatype: {
          type: "select",
          disabled: false,
          predeterminate: "1",
          list: "list_aportante",
          label: 'name'
        }
      },
      id_list_arl: {
        type: "text",
        label: "ARL",
        placeholder: "",
        namepath: ['admin_razones'],
        description: "",
        validate: "",
        datatype: {
          type: "select",
          disabled: false,
          predeterminate: "1",
          list: "list_arl",
          label: 'name'
        }
      },
      id_list_ccf: {
        type: "text",
        label: "CCF",
        placeholder: "",
        namepath: ['admin_razones'],
        description: "",
        validate: "",
        datatype: {
          type: "select",
          disabled: false,
          predeterminate: "1",
          list: "list_ccf",
          label: 'name'
        }
      },
      exonerado: {
        type: "boolean",
        label: "Exonerado de parafiscales y salud",
        placeholder: "",
        namepath: ['admin_razones'],
        description: "",
        validate: "",
        datatype: {
          type: "check",
          disabled: false,
          predeterminate:0,
        }
      },      
      retiroparafiscales: {
        type: "boolean",
        label: "Calcular vacaciones de parafiscales al retirar",
        placeholder: "",
        namepath: ['admin_razones'],
        description: "",
        validate: "",
        datatype: {
          type: "check",
          disabled: false,
          predeterminate:1,
        }
      }, 
      nota_delete: {
        type: "text",
        label: "Nota",
        placeholder: "",
        namepath: [''],
        description: "",
        validate: "required",
        datatype: {
          type: "input",
          disabled: false,
          predeterminate: null
        }
      }, 
    }
  }
}

